export default __webpack_public_path__ + "static/media/Background_00126.57c29183.png";